import React from 'react';
import logo from 'images/odin-logo.svg';
import { cn, getCurrentDomain } from 'utils';
import { useScaleOnResize } from 'utils/useScaleOnResize';
import QRCode from 'react-qr-code';

export type LegacyTempBadgePreviewProps = {
  jobsiteName: string;
  badgeName: string;
  className?: string;
};

export function LegacyTempBadgePreview(
  props: LegacyTempBadgePreviewProps,
): React.ReactElement {
  const { jobsiteName, badgeName, className } = props;
  const { containerRef, containerStyle, subContainerStyle } =
    useScaleOnResize<HTMLDivElement>({ baseWidth: 420, baseHeight: 248 });

  return (
    <div ref={containerRef} className={cn(className)} style={containerStyle}>
      <div
        className={cn(
          'odin-bg-white odin-border odin-border-gray-200 odin-rounded-2xl ',
          'odin-shadow-odin-normal odin-overflow-hidden',
        )}
        style={subContainerStyle}
      >
        <div className="odin-w-full odin-h-full odin-flex">
          <div className="odin-grow odin-flex odin-flex-col odin-justify-between">
            <div className="odin-px-6 odin-pt-5 odin-pb-2 odin-flex odin-flex-col odin-gap-1">
              <div className="odin-flex odin-items-center odin-justify-between">
                <img
                  src={logo}
                  alt="Odin Logo"
                  className="odin-h-11 odin-w-auto"
                />
                <QRCode value={getCurrentDomain()} size={55} />
              </div>

              <div className="odin-text-2xl odin-font-medium odin-mt-3">
                {badgeName}
              </div>

              <div className="odin-text-base sm:odin-text-lg odin-font-medium odin-text-gray-700">
                {jobsiteName}
              </div>
            </div>

            <div className="odin-text-odin-danger odin-font-medium odin-text-base sm:odin-text-lg odin-px-4 odin-py-3">
              Please return badge when exiting
            </div>
          </div>
          <div className="[writing-mode:vertical-lr] odin-rotate-180 odin-bg-odin-danger odin-text-white odin-text-center odin-font-semibold odin-tracking-wide odin-text-4xl odin-px-3">
            TEMPORARY
          </div>
        </div>
      </div>
    </div>
  );
}
